import { RoomReportFiltersInterface } from '@app/types/rooms';
import { api } from '../../utils';

const buildingsBaseApi = 'buildings';
const reportsBaseApi = 'reports';

class ModuleApi {
  getAllBuildings() {
    return api.get(`${buildingsBaseApi}`);
  }

  reportRoomsByBuilding(
    building: number,
    showOnlyActiveRooms: boolean,
    limit: number,
    page: number,
    order: RoomReportFiltersInterface
  ) {
    return api.post(`${reportsBaseApi}/room-report-by-building`, {
      building,
      showOnlyActiveRooms,
      limit,
      page,
      order
    });
  }

  getRoomDataById(id: string) {
    return api.get(`rooms/${id}`);
  }
}

export default new ModuleApi();
